// WebRTC connects from the browser itself, outside the proxy: a STUN server would see, and tell
// the page, the visitor's real address. Peer connections are kept, but gather no candidates
// (relay only, with no relay servers), as in Chrome set to never send UDP outside a proxy.

import { ScramjetClient } from "@client/index";

export default function (client: ScramjetClient, self: any) {
	if (!self.RTCPeerConnection) return;

	const contained = (config: any) => {
		const safe =
			config && typeof config === "object" ? { ...config } : ({} as any);
		safe.iceServers = [];
		safe.iceTransportPolicy = "relay";

		return safe;
	};

	client.Proxy("RTCPeerConnection", {
		construct(ctx) {
			ctx.args[0] = contained(ctx.args[0]);
		},
	});
	client.Proxy("RTCPeerConnection.prototype.setConfiguration", {
		apply(ctx) {
			ctx.args[0] = contained(ctx.args[0]);
		},
	});

	// The same constructor under its old name, as in Chrome.
	if (self.webkitRTCPeerConnection) {
		self.webkitRTCPeerConnection = self.RTCPeerConnection;
	}
}
